// Default styles for Vuetify components

export default {
  global: {
    ripple: true,
  },
  VAppBar: {
    color: 'liv-app-bar-bg-color',
    class: 'px-md-4',
    density: 'comfortable',
    elevation: 2,
  },
  VAppBarNavIcon: {
    color: 'liv-app-bar-nav-icon-color', // without `text-`
  },
  VAppBarTitle: {
    class: 'text-liv-app-bar-title-color',
  },
  VFooter: {
    color: 'liv-footer-bg-color',
    class: 'py-2',
    elevation: 2,
  },
  VDataTable: {
    class: 'elevation-1',
    itemClass: 'datatable-row',
    VDataTableRows: {
      class: 'datatable-rows', // Defined in `DataTable.vue`
    },
  },
  VCard: {
    elevation: 3,
    rounded: 'lg',
  },
  VChip: {
    size: 'default',
    density: 'comfortable',
  },
  VTextField: {
    variant: 'outlined',
    density: 'compact',
    // color: '#0d61aa', // Border and Label color when active or focused
    // rounded: '4px', // 'sm' is 2px, 'lg' is 8px
    // Global settings border radius for all components is set with `$border-radius-root` in `/resources/styles/vuetify.scss` from Vuetify doc
    // The resulting border radius = max(global settings with `$border-radius-root` , local override with `rounded` ) )
  },
  VNumberInput: {
    variant: 'outlined',
    controlVariant: 'stacked',
    density: 'compact',
  },
  VSelect: {
    variant: 'outlined',
    density: 'compact',
    // Color properties, automatically inherited from VTextField
  },
  VFileInput: {
    variant: 'outlined',
    density: 'compact',
  },
  VFileUpload: {
    density: 'compact',
  },
  // VBtn: {
  //   style: 'text-transform: none;', // Already using SCSS variables in `/resources/styles/vuetify.scss`
  // },

  // VNavigationDrawer: {
  //   width: 300,
  // },

  // VContainer: {
  //   class: 'px-4 py-2', // consistent spacing
  // },

  // VForm: {
  //   class: 'pa-4',
  // },

  // VBtn: {
  // color: 'primary',
  // variant: 'elevated',
  // rounded: 'lg',
  // elevation: 2,
  // class: 'text-white font-semibold px-4 py-2',
  // },

  // VSelect: {
  //   variant: 'outlined',
  //   density: 'comfortable',
  //   color: 'primary',
  //   bgColor: 'surface',
  //   rounded: 'lg',
  //   class: 'mb-2',
  //   hideDetails: 'auto',
  //   persistentPlaceholder: true,
  // },

  // VTextarea: {
  //   variant: 'outlined',
  //   density: 'comfortable',
  //   color: 'primary',
  //   bgColor: 'surface',
  //   rounded: 'lg',
  //   class: 'mb-2',
  //   hideDetails: 'auto',
  //   persistentPlaceholder: true,
  // },
};
